import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
// import getters from './getters'
import tagsView from './modules/tagsView'



// 引用 Vuex插件
Vue.use(Vuex)


const store = new Vuex.Store({
  state: state,
  mutations: mutations,
  modules :{
    tagsView
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js